import { render, staticRenderFns } from "./CopyrightBlogItem.vue?vue&type=template&id=615d8d9b&scoped=true&"
import script from "./CopyrightBlogItem.vue?vue&type=script&lang=js&"
export * from "./CopyrightBlogItem.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightBlogItem.vue?vue&type=style&index=0&id=615d8d9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d8d9b",
  null
  
)

export default component.exports